import frontendAppLearnerDashboardMessages from './messages/@edx/frontend-app-learner-dashboard';
import paragonMessages from './messages/@openedx/paragon';

export default [
  frontendAppLearnerDashboardMessages,
  paragonMessages,
];
